// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kefu-bott[data-v-14e7d7c4]{width:1200px;margin:0 auto;padding-top:50px;padding-bottom:50px;justify-content:space-between;display:flex}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
